// Memorial entry for Omer Neutra
import omerNeutraPortrait from '../../../images/omer-neutra.jpg';

export const omerNeutraMemorial = {
  id: 40,
  name: 'Cpt. Omer Neutra',
  images: {
    portrait: omerNeutraPortrait
  },
  info: `
"It's my turn to show my love to Israel in action and not just in words." - Omer, explaining why he chose to serve

# Captain Omer Neutra

![Omer Neutra](${omerNeutraPortrait})
*Captain Omer Neutra, 21, Israeli-American tank commander*

## An American Heart, An Israeli Soul

Omer Neutra was born in Manhattan one month after September 11, 2001. His mother Orna, eight months pregnant, walked home across the Queensborough Bridge that day. He grew up in Plainview, Long Island - captain of the basketball, volleyball, and soccer teams, lifeguard at Camp Ramah, regional president of United Synagogue Youth.

He was accepted to Binghamton University. Instead, he chose Israel.

As a grandson of Holocaust survivors on both sides, Omer believed it was his turn to protect the Jewish people. He made aliyah and enlisted as a "lone soldier" in the IDF's 7th Armored Brigade.

He became a tank platoon commander.

## October 7, 2023

Omer was stationed at a post between Kibbutz Nir Oz and Nirim when Hamas attacked. His parents had spoken to him October 6 - he said his unit was told to lower their alert for a "more relaxed weekend."

His tank crew of four faced the assault. The tank malfunctioned. Hamas attacked with RPGs and explosives.

Omer, Oz Daniel, and Shaked Dahan were killed. Nimrod Cohen was taken hostage.

For over a year, his family believed Omer had been captured alive. On December 1, 2024, the IDF confirmed he had been killed on October 7.

## His Parents' Fight

Ronen and Orna Neutra became two of the most visible hostage advocates. They spoke at the Republican National Convention, met with Biden, Sullivan, Burns, and Congress. They appeared at both Democratic and Republican events.

"We have two presidents," Orna said. "We're calling on them to work together."

## Coming Home

Omer's remains returned November 2, 2025 - 759 days later. His father Ronen: "Omer is on Israeli soil. Finally. So much pain and so much relief."

At his funeral in Tel Aviv, his brother Daniel wore Omer's jacket: "You were my best friend. Thank you for everything."

His school retired his jersey number 24 and created the Omer Neutra Legacy Fund for students choosing gap years in Israel.

His father's eulogy: "We know that until your last breath, you thought about your crew, about the people of Israel. You were a hero, not because you were killed in war, but because of the way you lived."

*Warm, optimistic and people-loving - he lit up the room. May his memory be a blessing.*

[Read more](https://www.timesofisrael.com/an-american-heart-with-an-israeli-soul-omer-neutra-laid-to-rest-in-tel-aviv/)
`
};
